module.exports = __webpack_public_path__ + "static/media/img-navDrawer--open.d1fdcc46.svg";